import { useEffect, useState } from "react";

/**
 * True while the browser tab is visible. Lets polling loops pause when the
 * tab is backgrounded (saves server load + battery on a self-hosted box) and
 * resume when the user comes back. Callers typically gate their `setInterval`
 * fetch on this and do one immediate refetch on the visible→true transition
 * so the UI is fresh the instant the tab regains focus.
 */
export function usePageVisible(): boolean {
	const [visible, setVisible] = useState<boolean>(() =>
		typeof document === "undefined" ? true : document.visibilityState === "visible",
	);

	useEffect(() => {
		const onChange = () => setVisible(document.visibilityState === "visible");
		document.addEventListener("visibilitychange", onChange);
		return () => document.removeEventListener("visibilitychange", onChange);
	}, []);

	return visible;
}
